import { Component } from '@angular/core'
import { Message } from '@mprep/shared/core/models/'
import { Observable } from 'rxjs/Observable'

import { PopupNotificationService } from './../../'

@Component({
  selector: 'mp-popup-notification',
  templateUrl: './popup-notification.html',
  styleUrls: ['./popup-notification.scss']
})

export class PopupNotificationComponent {
  constructor(
    public data: PopupNotificationService
  ) {}

  public invokeAction(action) {
    const functionName = `${action.type}Action`
    const actionFn = this[functionName]
    if (!actionFn && actionFn instanceof Function && functionName.charAt(0) !== '_') {
      throw new Error(`Action function '${functionName}' does not exist!`)
    }
    return actionFn.call(this, action)
  }

  private hideMessageAction(action): void {
    this.data.message = null
  }

  private extendAccessAction(action): void {
    window.open(action.value)
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/popup-notification/popup-notification.component.ts